import { IDLE } from "../../global/statusLabels";
import { GET_AVVISI_UTENTE_SUCCESS, GET_PRESA_VISIONE_SUCCESS, GET_PROFILO_SUCCESS, GET_ULTIMA_INFORMATIVA_SUCCESS, PATCH_PROFILO_SUCCESS, POST_PRESA_VISIONE_SUCCESS, POST_PROFILO_SUCCESS, RESET_PROFILAZIONE_STATE } from "./actionsType";

const initialState = {
    profilo: { value: undefined, status: IDLE },
    postProfilo: { value: undefined, status: IDLE },
    presaVisione: { value: undefined, status: IDLE },
    informativaPrivacy: { value: undefined, status: IDLE },
    avvisiUtente: { value: undefined, status: IDLE },
}

export const profilazioneReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PROFILO_SUCCESS:
        case PATCH_PROFILO_SUCCESS:
            return {
                ...state,
                profilo: action.payload
            }
        case POST_PROFILO_SUCCESS:
            return {
                ...state,
                postProfilo: action.payload
            }
        case GET_PRESA_VISIONE_SUCCESS:
        case POST_PRESA_VISIONE_SUCCESS:
            return {
                ...state,
                presaVisione: action.payload
            }
        case GET_ULTIMA_INFORMATIVA_SUCCESS:
            return {
                ...state,
                informativaPrivacy: action.payload
            }
        case GET_AVVISI_UTENTE_SUCCESS:
            return {
                ...state,
                avvisiUtente: action.payload
            }
        case RESET_PROFILAZIONE_STATE:
            return initialState

        case 'persist/REHYDRATE':
            return state;

        default:
            return state;
    }
}